"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_loader_provider_1 = require("../fragments-loader-provider");
const mount_1 = require("../utils/mount");
const MOUNTED_STATE = 'MOUNTED';
exports.default = {
    props: {
        name: { type: String, required: true },
        className: { type: String, required: false, default: '' },
        tagName: { type: String, required: false, default: 'div' },
        props: { type: Object, required: false, default: () => { } }
    },
    methods: {
        getUniqueName() {
            if (!window.globalMountingCounter) {
                window.globalMountingCounter = 0;
            }
            return `${this.name}-${++window.globalMountingCounter}`;
        }
    },
    async mounted() {
        try {
            const module = await fragments_loader_provider_1.FragmentsLoaderProvider.fragmentsLoader.loadFragment(this.name);
            if (!module) {
                throw Error(`[Fragment] "${this.name}" module loading error.`);
            }
            const mountUtils = mount_1.MountUtils.createInstance(this);
            this.instance = await mountUtils.mountModule({ name: this.getUniqueName(), ...module }, this.props, this.$refs.container);
            await this.instance.mountPromise;
            this.$emit('mounted');
        }
        catch (e) {
            this.$emit('error', e);
        }
    },
    destroyed() {
        setTimeout(async () => {
            var _a, _b;
            try {
                if (((_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.getStatus) === null || _b === void 0 ? void 0 : _b.call(_a)) === MOUNTED_STATE) {
                    await this.instance.unmount();
                }
                this.$emit('unmounted');
            }
            catch (e) {
                this.$emit('error', e);
            }
        }, 10);
    },
    render(createElement) {
        const props = { ref: 'container' };
        if (this.className) {
            props.class = this.className;
        }
        return createElement(this.tagName, props);
    },
    watch: {
        props: {
            async handler() {
                var _a;
                try {
                    if ((_a = this.instance) === null || _a === void 0 ? void 0 : _a.update) {
                        await this.instance.update(this.getFragmentProps());
                        this.$emit('updated');
                    }
                }
                catch (e) {
                    this.$emit('error', e);
                }
            }
        }
    }
};
